export default theme => ({
  selectedRow: {
    backgroundColor: theme.palette.userSecondary.dark,
  },
});
